import * as generatedServices from "./_generated";

export = generatedServices;